export default {
  en: {
    projects: [
      {
        id: 1,
        name: 'GootaxPro',
        src: 'https://firebasestorage.googleapis.com/v0/b/testingsystemdls.appspot.com/o/freelance%2Fgootax.jpeg?alt=media&token=a01cf658-9337-4bec-9122-96c54c8f8d68',
        href: 'https://www.gootax.pro',
        stack: 'Stack: YII2, JavaScript, RestAPI, MySQL, Php7, CSS3, HTML5'
      },
      {
        id: 2,
        name: 'Acorsoft',
        src: 'https://firebasestorage.googleapis.com/v0/b/testingsystemdls.appspot.com/o/freelance%2Fsmash.jpeg?alt=media&token=2fcdaf0f-8fe4-4c76-850f-2d8286304739',
        href: 'http://www.smashingsoftware.ru',
        stack: 'Stack: YII2, JavaScript, MySQL, Php7, CSS3, HTML5, Bootstrap3'
      }
    ],
    myProjects: [
      {
        id: 11,
        name: 'Employee Testing System',
        src: 'https://firebasestorage.googleapis.com/v0/b/testingsystemdls.appspot.com/o/freelance%2Ftesting.jpg?alt=media&token=5b5a6274-7380-49aa-8dcd-365748d16d54',
        href: 'http://test.dls.gov.ua/',
        stack: 'Stack: MySQL, Php5, CSS3, HTML5, Bootstrap3'
      },
      {
        id: 12,
        name: 'SkinLtd CRM system (backend)',
        src: 'https://firebasestorage.googleapis.com/v0/b/testingsystemdls.appspot.com/o/freelance%2FNew-Skin3.jpeg?alt=media&token=233a0cc3-50d5-48a8-8a11-96ff12a10ca2',
        href: 'https://skin.in.ua/',
        stack: 'Stack: YII2, JavaScript, MySQL, Php7, CSS3, HTML5, Bootstrap3'
      },
      {
        id: 13,
        name: 'Personal webpage',
        src: 'https://firebasestorage.googleapis.com/v0/b/testingsystemdls.appspot.com/o/freelance%2FDLS_h_1000.jpg?alt=media&token=61e71562-3f37-4fa0-999f-4e9c429a7dc4',
        href: 'https://vld-ukraine.web.app/',
        stack: 'Stack: VueJS, JavaScript, FireBase, Vuetify, CSS3, HTML5'
      }
    ]
  },
  uk: {
    projects: [
      {
        id: 1,
        name: 'Хмарний сервіс GootaxPro',
        src: 'https://firebasestorage.googleapis.com/v0/b/testingsystemdls.appspot.com/o/freelance%2Fgootax.jpeg?alt=media&token=a01cf658-9337-4bec-9122-96c54c8f8d68',
        href: 'https://www.gootax.pro',
        stack: 'Стек: YII2, JavaScript, RestAPI, MySQL, Php7, CSS3, HTML5'
      },
      {
        id: 2,
        name: 'Портал завантаження Acorsoft',
        src: 'https://firebasestorage.googleapis.com/v0/b/testingsystemdls.appspot.com/o/freelance%2Fsmash.jpeg?alt=media&token=2fcdaf0f-8fe4-4c76-850f-2d8286304739',
        href: 'http://www.smashingsoftware.ru',
        stack: 'Стек: YII2, JavaScript, MySQL, Php7, CSS3, HTML5, Bootstrap3'
      }
    ],
    myProjects: [
      {
        id: 11,
        name: 'Система тестування персоналу Держлікслужби',
        src: 'https://firebasestorage.googleapis.com/v0/b/testingsystemdls.appspot.com/o/freelance%2Ftesting.jpg?alt=media&token=5b5a6274-7380-49aa-8dcd-365748d16d54',
        href: 'http://test.dls.gov.ua/',
        stack: 'Стек: MySQL, Php5, CSS3, HTML5, Bootstrap3'
      },
      {
        id: 12,
        name: 'ТОВ СКИН CRM система (backend)',
        src: 'https://firebasestorage.googleapis.com/v0/b/testingsystemdls.appspot.com/o/freelance%2FNew-Skin3.jpeg?alt=media&token=233a0cc3-50d5-48a8-8a11-96ff12a10ca2',
        href: 'https://skin.in.ua/',
        stack: 'Стек: YII2, JavaScript, MySQL, Php7, CSS3, HTML5, Bootstrap3'
      },
      {
        id: 13,
        name: 'Моя сторінка',
        src: 'https://firebasestorage.googleapis.com/v0/b/testingsystemdls.appspot.com/o/freelance%2FDLS_h_1000.jpg?alt=media&token=61e71562-3f37-4fa0-999f-4e9c429a7dc4',
        href: 'https://vld-ukraine.web.app/',
        stack: 'Стек: VueJS, JavaScript, FireBase, Vuetify, CSS3, HTML5'
      }
    ]
  },
  ru: {
    projects: [
      {
        id: 1,
        name: 'Облачный сервис GootaxPro',
        src: 'https://firebasestorage.googleapis.com/v0/b/testingsystemdls.appspot.com/o/freelance%2Fgootax.jpeg?alt=media&token=a01cf658-9337-4bec-9122-96c54c8f8d68',
        href: 'https://www.gootax.pro',
        stack: 'Стек: YII2, JavaScript, RestAPI, MySQL, Php7, CSS3, HTML5'
      },
      {
        id: 2,
        name: 'Портал програмного обеспечения Acorsoft',
        src: 'https://firebasestorage.googleapis.com/v0/b/testingsystemdls.appspot.com/o/freelance%2Fsmash.jpeg?alt=media&token=2fcdaf0f-8fe4-4c76-850f-2d8286304739',
        href: 'http://www.smashingsoftware.ru',
        stack: 'Стек: YII2, JavaScript, MySQL, Php7, CSS3, HTML5, Bootstrap3'
      }
    ],
    myProjects: [
      {
        id: 11,
        name: 'Система тестирования персонала',
        src: 'https://firebasestorage.googleapis.com/v0/b/testingsystemdls.appspot.com/o/freelance%2Ftesting.jpg?alt=media&token=5b5a6274-7380-49aa-8dcd-365748d16d54',
        href: 'http://test.dls.gov.ua/',
        stack: 'Стек: MySQL, Php5, CSS3, HTML5, Bootstrap3'
      },
      {
        id: 12,
        name: 'SkinLtd CRM система (backend)',
        src: 'https://firebasestorage.googleapis.com/v0/b/testingsystemdls.appspot.com/o/freelance%2FNew-Skin3.jpeg?alt=media&token=233a0cc3-50d5-48a8-8a11-96ff12a10ca2',
        href: 'https://skin.in.ua/',
        stack: 'Стек: YII2, JavaScript, MySQL, Php7, CSS3, HTML5, Bootstrap3'
      },
      {
        id: 13,
        name: 'Моя личная страница',
        src: 'https://firebasestorage.googleapis.com/v0/b/testingsystemdls.appspot.com/o/freelance%2FDLS_h_1000.jpg?alt=media&token=61e71562-3f37-4fa0-999f-4e9c429a7dc4',
        href: 'https://vld-ukraine.web.app/',
        stack: 'Стек: VueJS, JavaScript, FireBase, Vuetify, CSS3, HTML5'
      }
    ]
  }
}
